import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIcon } from '@yonderland/andes-icons';
import { Tooltip, TextAlpha, StatusIndicator, Icon, LinkButton, } from '@yonderland/andes-react';
import { COUNTDOWN, ENABLED_DELIVERY_PROMISES } from '../../constants/DeliveryConstants';
import { useCountdownTimer } from '../../hooks/useCountdownTimer';
const deliveryPromiseConfig = {
    'pdp+basket': {
        cc: {
            direct: { status: 'complete' },
            delayed: { status: 'partiallyComplete' },
            unavailable: { status: 'unavailable' },
        },
        ccSpecific: {
            direct: { status: 'complete' },
            delayed: { status: 'partiallyComplete' },
            unavailable: { status: 'incomplete' },
        },
        hd: {
            direct: { status: 'complete', color: 'success', emphasized: true },
            delayed: { status: 'partiallyComplete', emphasized: true },
            unavailable: { status: 'unavailable' },
        },
    },
    'product-tile': {
        cc: {
            direct: { status: 'complete', align: 'end' },
            delayed: { status: 'partiallyComplete', align: 'end' },
            unavailable: { status: 'unavailable', align: 'end' },
        },
        ccSpecific: {
            direct: { status: 'complete', align: 'end' },
            delayed: { status: 'partiallyComplete', align: 'end' },
            unavailable: { status: 'incomplete', align: 'end' },
        },
        hd: {
            direct: { status: 'complete', color: 'success', align: 'end' },
            delayed: { status: 'partiallyComplete', align: 'end' },
            unavailable: { status: 'unavailable', align: 'end' },
        },
    },
    ssm: {
        cc: {
            direct: { status: 'complete' },
            delayed: { status: 'partiallyComplete' },
            unavailable: { status: 'incomplete' },
        },
    },
};
export const DeliveryPromiseMessage = ({ state, touchPoint, option, message, standardDeliveryLabel, testId, type, explanation, cutoff, cta, }) => {
    var _a, _b;
    const { countdownMessage } = useCountdownTimer(cutoff, message);
    if (!message || !countdownMessage)
        return null;
    const { status, color, emphasized, align } = (_b = (_a = deliveryPromiseConfig[touchPoint]) === null || _a === void 0 ? void 0 : _a[option]) === null || _b === void 0 ? void 0 : _b[state];
    const isCountdownTimer = cutoff && message.includes(COUNTDOWN) && ENABLED_DELIVERY_PROMISES.includes(type || '');
    return (_jsxs(StatusIndicator, { status: status, testId: testId, align: align, children: [_jsxs(TextAlpha, { as: "span", color: color, strong: emphasized, children: [standardDeliveryLabel && (_jsxs(_Fragment, { children: [standardDeliveryLabel, _jsx("br", {})] })), isCountdownTimer ? _jsx("span", { dangerouslySetInnerHTML: { __html: countdownMessage } }) : message] }), cta && (_jsxs(_Fragment, { children: [cta.prefix ? ` ${cta.prefix} ` : ' ', _jsx(LinkButton, { testId: "delivery-promise-store-cta", text: _jsx(TextAlpha, { as: "span", strong: true, children: cta.text }), onClick: cta.onClick })] })), explanation && (_jsxs(_Fragment, { children: [' ', _jsx(Tooltip, { text: explanation, hasCloseBtn: false, children: _jsx(Icon, { source: InfoIcon, size: "xs", color: color }) })] }))] }));
};
